export const classList = (classNames) => (classNames || []).filter(it => !!it).join(' ')

export const joinWords = (words) => words.filter(it => !!it).join(' ')
